<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <tipping-control></tipping-control>
      <tipping-view></tipping-view>
    </v-layout>
  </v-container>
</template>

<script>
import TippingControl from "./components/tippingControl";
import TippingView from "./components/tippingView";
export default {
  components: {
    TippingControl,
    TippingView
  }
};
</script>

<style scoped>
</style>

